.wrap {
  width: 100%;
  max-width: var(--container-narrow);
  margin: 0 auto;
  padding: var(--space-12) var(--space-6) var(--space-20);
}

.title {
  font-family: var(--font-heading);
  font-weight: 700;
  font-size: var(--text-4xl);
  line-height: 1.1;
  letter-spacing: -0.02em;
  margin-bottom: var(--space-4);
}

.subtitle {
  color: var(--color-text-muted);
  font-size: var(--text-lg);
  line-height: 1.6;
  margin-bottom: var(--space-12);
  max-width: 56ch;
}

.sectionTitle {
  font-family: var(--font-heading);
  font-weight: 700;
  font-size: var(--text-2xl);
  letter-spacing: -0.01em;
  margin-bottom: var(--space-6);
}

/* ─── Canales de contacto ─── */
.channels {
  list-style: none;
  padding: 0;
  margin: 0 0 var(--space-6);
  display: grid;
  grid-template-columns: 1fr;
  gap: var(--space-4);
}

@media (min-width: 720px) {
  .channels {
    grid-template-columns: repeat(3, 1fr);
  }
}

.channel {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  background: var(--color-surface);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-xl);
  padding: var(--space-6);
}

.channelLabel {
  font-family: var(--font-body);
  font-size: var(--text-xs);
  font-weight: 600;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: var(--color-text-muted);
}

.channelValue {
  font-family: var(--font-heading);
  font-weight: 700;
  font-size: var(--text-lg);
  letter-spacing: -0.01em;
  color: var(--color-text);
  text-decoration: none;
  word-break: break-word;
}

.channelValue:hover {
  color: var(--color-primary);
}

.channelDescription {
  font-size: var(--text-sm);
  line-height: 1.55;
  color: var(--color-text-muted);
  flex: 1;
}

.channelAction {
  align-self: flex-start;
  margin-top: var(--space-2);
  padding: var(--space-2) var(--space-5);
  min-height: 40px;
  display: inline-flex;
  align-items: center;
  background: var(--color-primary);
  color: var(--color-text-inverse);
  border-radius: var(--radius-full);
  font-size: var(--text-sm);
  font-weight: 600;
  text-decoration: none;
  transition: background-color var(--duration-fast) var(--ease-standard);
}

.channelAction:hover {
  background: var(--color-primary-hover);
}

.responseTime {
  font-size: var(--text-sm);
  color: var(--color-text-muted);
  margin-bottom: var(--space-16);
}

/* ─── Eliminar cuenta ─── */
.deletion {
  background: var(--color-surface);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-xl);
  padding: var(--space-8);
}

.deletionTitle {
  font-family: var(--font-heading);
  font-weight: 700;
  font-size: var(--text-2xl);
  letter-spacing: -0.01em;
  margin-bottom: var(--space-4);
}

.deletionSubhead {
  font-family: var(--font-heading);
  font-weight: 600;
  font-size: var(--text-lg);
  color: var(--color-text);
  margin: var(--space-6) 0 var(--space-3);
}

.deletionText {
  color: var(--color-text);
  font-size: var(--text-base);
  line-height: 1.7;
  margin-bottom: var(--space-3);
}

.optionsList {
  padding-left: var(--space-6);
  margin: 0 0 var(--space-3);
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
}

.optionsList li {
  font-size: var(--text-base);
  line-height: 1.6;
  color: var(--color-text);
}

.whatList {
  list-style: none;
  padding: 0;
  margin: 0 0 var(--space-6);
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
}

.whatList li {
  display: flex;
  align-items: center;
  gap: var(--space-3);
  font-size: var(--text-base);
  color: var(--color-text);
}

.whatList li::before {
  content: '';
  width: 8px;
  height: 8px;
  border-radius: var(--radius-full);
  background: var(--color-primary);
  flex-shrink: 0;
}

.inlineLink {
  color: var(--color-primary);
  text-decoration: none;
  font-weight: 600;
}

.inlineLink:hover {
  text-decoration: underline;
}

@media (max-width: 640px) {
  .wrap {
    padding: var(--space-8) var(--space-4) var(--space-16);
  }

  .title {
    font-size: var(--text-3xl);
  }

  .deletion {
    padding: var(--space-6);
  }
}
